<template lang="">
    <v-chip
      small
      :color="
        status === 'paid'
          ? '#07C07E1A'
          : status === 'unpaid'
          ? '#E71D1D26'
          : '#f2f2f7'
      "
    >
      <span
        class="p-3 font-weight-bold"
        :style="
          status === 'paid'
            ? 'color: #07C07E'
            : status === 'unpaid'
            ? 'color: #E71D1D'
            : 'color: #797997'
        "
      >
        {{ status }}
      </span>
    </v-chip>
  </template>
  <script>
  export default {
    props: {
      status: String,
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-chip {
    text-transform: capitalize;
    font-weight: $font-weight-bold;
    &::before {
      display: none;
    }
  }
  </style>
  